import { getPlayerCount } from '@/modules/count/slice';
import { PlayerCountIcon } from '@/modules/lobby/svg';
import { RwdSvgIcon as NewRwdSvgIcon } from '@/modules/rwdGame/components/RwdSvgIcon/RwdSvgIcon';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import { RootState } from '@/store/store';
import { numberFormat } from '@/utils/commonFunc';
import Stack from '@mui/material/Stack';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

type PlayerCountProps = {
    hostId: number;
    showBet?: boolean;
};

export const FooterPlayerCount = ({ hostId }: PlayerCountProps) => {
    const countState = useSelector((state: RootState) =>
        getPlayerCount(state, hostId)
    );
    const display = useMemo(
        () => numberFormat(countState.Count, 0),
        [countState]
    );
    return (
        <Stack direction="row" alignItems="center" gap={'0.3rem'}>
            <NewRwdSvgIcon portraitIconSize={14} landscapeIconSize={32}>
                <PlayerCountIcon className="multibet-player-count" />
            </NewRwdSvgIcon>
            <RwdTypography stepIndex={-1} landscapeStepIndex={3}>
                {display}
            </RwdTypography>
        </Stack>
    );
};
